import { Link } from "react-router-dom";

import { Card } from "../components/Card";
import { useSession } from "../lib/session";

export function NotFoundPage() {
  const me = useSession();
  const home = me?.role === "admin" ? "/admin/laporan" : "/input";

  return (
    <Card className="mx-auto mt-8 max-w-xl text-center">
      <p className="accent-text-gradient text-5xl font-black">404</p>
      <h2 className="mt-4 text-lg font-bold text-text">Halaman tidak ditemukan</h2>
      <p className="mt-2 text-sm text-muted">
        Alamat yang Anda buka tidak tersedia atau sudah dipindahkan.
      </p>
      <Link
        to={home}
        className="mt-6 inline-flex items-center justify-center rounded-control accent-gradient px-5 py-3 text-sm font-semibold text-white shadow-clay transition-all active:clay-pressed"
      >
        Kembali ke halaman utama
      </Link>
    </Card>
  );
}
